export const CHART_EVENT = {
  exported: 'MARK Chart Exported',
} as const satisfies Record<string, string>;

export type ChartEventName = (typeof CHART_EVENT)[keyof typeof CHART_EVENT];

export type ChartExportStatus = 'successful' | 'errored';
